import AddressSearchMenuItem from './address-search-menu-item';

export default AddressSearchMenuItem;
